import { info, error } from '@/utils/safetyLog'

export const getTranslation = async (locale: string) => {
  try {
    const langDictionary = await import('@/locales/' + locale + '.json')
    return langDictionary
  } catch (e) {
    error('get module translation error: ', e)
    return {}
  }
}